@if (challenge()) {
  <div>
    <p>Pairing this device with:</p>
    <p class="mb-1 mt-3">Brand:</p>
    <h4>{{ challenge().brand }}</h4>
    @if (challenge().location) {
      <div>
        <p class="mb-1 mt-3">Location:</p>
        <h4>{{ challenge().location }}</h4>
      </div>
    }
    @if (challenge().floor) {
      <div>
        <p class="mb-1 mt-3">Floor:</p>
        <h4>{{ challenge().floor }}</h4>
      </div>
    }
    @if (challenge().room) {
      <div>
        <p class="mb-1 mt-3">Room:</p>
        <h4>{{ challenge().room }}</h4>
      </div>
    }
    <button class="btn btn-success mt-3"
            (click)="continue()">Continue</button>
  </div>
}